const PaymentType = {
    "BankWireDirectPayIn": "0",
    "MainWalletToTransaction": "1"
};

export default PaymentType;
